import type { UsageReportV2ReportItem } from '@vy/types';
import { isNotEmptyArray } from '@vy/utils';
import type { FilterLineType } from '../../../../components/new-design/vyTableFilter';
import { matchesStringSelection } from '../../reports-components/shared-filter-fields';
import { USAGE_REPORT_V2_FILTER_FIELD_IDS } from './usage-report-v2-filter-field-ids';

type FilterPredicate = (item: UsageReportV2ReportItem, value: unknown) => boolean;

const FIELD_PREDICATES: Record<string, FilterPredicate> = {
  [USAGE_REPORT_V2_FILTER_FIELD_IDS.CustomerId]: (item, value) =>
    matchesStringSelection(item.customer.id, value),

  [USAGE_REPORT_V2_FILTER_FIELD_IDS.Plan]: (item, value) =>
    matchesStringSelection(item.contract.name, value),

  [USAGE_REPORT_V2_FILTER_FIELD_IDS.ContractStatus]: (item, value) =>
    matchesStringSelection(item.contract.status, value),

  [USAGE_REPORT_V2_FILTER_FIELD_IDS.PricingType]: (item, value) =>
    matchesStringSelection(item.product.pricingModel, value),
};

export function applyUsageReportV2Filters(
  reportItems: UsageReportV2ReportItem[],
  filters: FilterLineType[],
): UsageReportV2ReportItem[] {
  if (!isNotEmptyArray(filters)) return reportItems;

  return reportItems.filter((item) =>
    filters.every((filter) => {
      const predicate = FIELD_PREDICATES[filter.field];
      if (!predicate) return true;
      return predicate(item, filter.value);
    }),
  );
}
